import React, { useContext, useEffect, useState } from "react";
import classNames from "classnames";
import { GlobalContext } from "../../globals/globalContext.jsx";
import {
  preFillPickupFields,
  preFillDeliveryFields,
} from "../../util/formHelpers.js";
import PickupForm from "./PickupForm";
import DeliveryForm from "./DeliveryForm";
import { FormattedMessage } from "react-intl";

const Profile = (props) => {
  const {
    className,
    slim,
    data = {},
    errors = {},
    onChange,
    onSaveClick,
    address,
    post_city,
    is_shipping,
    isDeliveryAddress,
    pickup_address,
    gmbhName,
    conditionsPage,
    changeTypeOfCustomer,
    timeframe,
    isRegistration,
    companyEmail,
    updateCoordinates,
    updateStreet,
  } = props;

  const { delivery_address } = useContext(GlobalContext);

  const [showBillingAddress, setShowBillingAddress] = useState(undefined);

  const accept_conditions = (
    <p className="paragraph left-p">
      <FormattedMessage id="agreementPreamble" />
      <a
        rel="noreferrer"
        className="terms-link"
        href={`https://${conditionsPage}`}
        target="_blank"
      >
        <FormattedMessage id="termsAndConditions" />
      </a>
      <FormattedMessage id="ofCompany" values={{ gmbhName: gmbhName }} />
    </p>
  );

  const onShowBillingAddressClick = ({ target: { checked } }) => {
    setShowBillingAddress(checked);
    setFormData((prevFormData) => ({
      ...prevFormData,
      different_invoice_address: checked,
    }));
  };

  useEffect(() => {
    if (!isDeliveryAddress) setShowBillingAddress(true);
    else if (showBillingAddress === undefined)
      setShowBillingAddress(data["different_invoice_address"]);
  }, [isDeliveryAddress]);

  const handleDataChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    onChange && onChange(event);
  };

  const defaultFormData = isDeliveryAddress
    ? preFillDeliveryFields(
        data,
        post_city,
        is_shipping,
        delivery_address,
        timeframe,
      )
    : preFillPickupFields(data, address, pickup_address, timeframe);

  const [formData, setFormData] = useState(defaultFormData);

  const commonProps = {
    slim,
    data: formData,
    errors,
    onChange: handleDataChange,
    onSaveClick,
    accept_conditions,
    showBillingAddress,
    companyEmail,
    className: classNames("profile", { "is-slim": slim }, className),
  };

  return isDeliveryAddress ? (
    <>
      <DeliveryForm
        {...commonProps}
        is_shipping={is_shipping}
        isRegistration={isRegistration}
        onShowBillingAddressClick={onShowBillingAddressClick}
        updateCoordinates={updateCoordinates}
        updateStreet={updateStreet}
        changeTypeOfCustomer={changeTypeOfCustomer}
      />
    </>
  ) : (
    <>
      <PickupForm
        {...commonProps}
        isRegistration={isRegistration}
        changeTypeOfCustomer={changeTypeOfCustomer}
      />
    </>
  );
};

export default Profile;
